import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { fetchDataFromAPI } from "../../utils/api";
import { getUser } from "../../utils/constants";
import { toast } from "react-toastify";

const Settings = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const admin = JSON.parse(getUser());
  const [newDriverPeriod, setNewDriverPeriod] = useState();
  const user = JSON.parse(getUser() || "{}");

  useEffect(() => {
    getPeriod();
  }, []);

  const getPeriod = () => {
    fetchDataFromAPI("admin/newDriverPeriod", "get", "", admin?.authToken)
      .then((res) => {
        console.log("res", res);
        setNewDriverPeriod(res?.data?.new_driver_period);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
          className: "bg-danger text-white",
        });
        console.log("error", error);
      });
  };

  const updatePeriod = () => {
    setLoading(true);

    const body = {
      new_driver_period: newDriverPeriod,
    };

    fetchDataFromAPI("admin/newDriverPeriod", "put", body, admin?.authToken)
      .then((res) => {
        console.log("res", res?.data?.new_driver_period);
        getPeriod();
        toast.success(res?.message, {
          position: toast.POSITION.TOP_RIGHT,
          className: "bg-success text-white",
        });
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
          className: "bg-danger text-white",
        });
        console.log("error", error);
      });
  };

  return (
    <div id="main" className="main">
      <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">Settings</li>
          </ol>
        </nav>
      </div>
      <div className="mt-4 mb-4">
        <h4>Driver</h4>
      </div>
      <div className="d-flex   align-items-center">
        <span className="fs-5">Company</span>
        <div className="">
          <i
            role="button"
            onClick={() => navigate("/company")}
            class="bi bi-pencil-square ms-4 fs-5 "
          ></i>
        </div>
      </div>

      <div
        className="d-flex justify-content-between align-items-center pt-2 "
        style={{ maxWidth: "600px" }}
      >
        {/* Left Side: Label and Description */}
        <div>
          <label className="form-label fw-bold mb-1">New Driver Period</label>
          <div className="text-muted fst-italic" style={{ fontSize: "0.9rem" }}>
            (number of days the system will consider an applicant as new)
          </div>
        </div>

        {/* Right Side: Input and Save Button */}
        <div className="d-flex align-items-center gap-2">
          <input
            type="number"
            value={newDriverPeriod}
            min={0}
            onChange={(e) => setNewDriverPeriod(Number(e.target.value))}
            className="form-control text-center"
            style={{ width: "80px" }}
            disabled={user?.type !== "super_admin"} // only super_admin can edit
          />
          <button
            type="button"
            className="btn btn-warning"
            onClick={updatePeriod}
            disabled={user?.type !== "super_admin" || loading} // disable for admin or when loading
          >
            {!loading && <span className="indicator-label">Save</span>}
            {loading && (
              <span className="indicator-progress" style={{ display: "block" }}>
                <span className="spinner-border spinner-border-sm align-middle"></span>
              </span>
            )}
          </button>
        </div>
      </div>
      {/* <div className="card"></div> */}
    </div>
  );
};

export default Settings;
